import React from "react";
import "../About.css";
import AboutHeader from "../components/AboutHeader/AboutHeader";
import AboutWhoWeAre from "../components/AboutWhoWeAre/AboutWhoWeAre";
import AboutWhyChooseUs from "../components/AboutWhyChooseUs/AboutWhyChooseUs";
import Team from "../components/Team/Team";
import AboutCTA from "../components/AboutCTA/AboutCTA";
const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <AboutHeader />
      {/* Who We Are */}
      <AboutWhoWeAre />
      {/* Why Choose Us */}
      <AboutWhyChooseUs />
      {/* Team Section */}
      <Team />
      {/* Call to Action */}
      <AboutCTA />
    </div>
  );
};

export default About;
